/** Entry point for content inherited from the base template. */

import { trackAll } from '../../client/analytics.js';

void trackAll();
